import Module from '../../../module';
import scroll from '../../../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			investorsResourcesMediaCoverageListLinkListItemCls: string;
			investorsResourcesMediaCoveragePagingCls: string;
			investorsResourcesMediaCoverageContentSectionDisclaimerCls: string;
		}
	},

	slug: string
}

class List extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Investors News List Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		// scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsNewsHeroContentSectionHeaderCls || '', 'investors_news_hero', { animCls: 'animate__fadeInDown', once: true});

		const pagingHtml = document.querySelector(this.publicVars.cssId.anim?.investorsResourcesMediaCoveragePagingCls || '');

		if(pagingHtml) {
			scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesMediaCoveragePagingCls || '', 'investors_resources_media_coverage_list', { animCls: 'animate__fadeIn', once: true});
		}

		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.investorsResourcesMediaCoverageContentSectionDisclaimerCls || '', 'investors_resources_media_coverage_list', { animCls: 'animate__fadeIn', once: true});

		if(this.publicVars.cssId.anim?.investorsResourcesMediaCoverageListLinkListItemCls) {

			const mediaCoverageItemsCount = document.querySelectorAll(
				this.publicVars.cssId.anim?.investorsResourcesMediaCoverageListLinkListItemCls).length;

			for (let i = 1; i <= mediaCoverageItemsCount; i++) {
				scroll.registerAnimatedElement(
					`${this.publicVars.cssId.anim?.investorsResourcesMediaCoverageListLinkListItemCls}${i}`,
					'investors_resources_media_coverage_list', { animCls: 'animate__fadeInLeft25P', once: true });
			}
		}
	}

	bind() {
		this.msg('bind');
	}
}

export default List;